export default __webpack_public_path__ + "static/media/sample.21b08d35.png";